import { set } from "date-fns";

export function getMinStartTime(selectedDate: Date | null): Date {
  const now = new Date();
  const isToday =
    selectedDate !== null &&
    selectedDate.getFullYear() === now.getFullYear() &&
    selectedDate.getMonth() === now.getMonth() &&
    selectedDate.getDate() === now.getDate();

  if (isToday && now.getHours() > 5) {
    return set(now, { hours: now.getHours(), minutes: now.getMinutes(), seconds: 0, milliseconds: 0 });
  }
  return set(now, { hours: 5, minutes: 0, seconds: 0, milliseconds: 0 });
}
